import { render, staticRenderFns } from "./VueEditor.vue?vue&type=template&id=a59688bc&scoped=true&"
import script from "./VueEditor.vue?vue&type=script&lang=js&"
export * from "./VueEditor.vue?vue&type=script&lang=js&"
import style0 from "./VueEditor.vue?vue&type=style&index=0&id=a59688bc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59688bc",
  null
  
)

export default component.exports